import { Component, OnInit, OnDestroy } from '@angular/core';
import { DynamicLoaderService } from '../../services/dynamic-loader.service';
import { UsersService } from '../../services/users.service';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

  hash: string;
  isValidToken: boolean;
  form: {
    Nuevacontrasena: string;
    ConfirmarNuevacontrasena: string;
  };
  error: string;

  constructor(
    private readonly dynamicLoaderService: DynamicLoaderService,
    private readonly route: ActivatedRoute,
    private readonly usersService: UsersService,
    private readonly router: Router
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.dynamicLoaderService.loadCSS('/assets/css/dashforge.auth.css');
    this.dynamicLoaderService.loadCSS('/assets/css/skin.light.css');

    this.hash = this.route.snapshot.queryParams.a;
    this.validateHash();
  }

  ngOnDestroy(): void {
    this.dynamicLoaderService.removeCSS('/assets/css/dashforge.auth.css');
    this.dynamicLoaderService.removeCSS('/assets/css/skin.light.css');
  }

  initForm(): void {
    this.form = {
      Nuevacontrasena: '',
      ConfirmarNuevacontrasena: '',
    };
  }

  async validateHash(): Promise<void> {
    try {
      const response = await this.usersService.validateHashRecoverPassword(this.hash);
      this.isValidToken = true;
    } catch (e) {
      this.isValidToken = false;
    }
  }

  async changePassword(): Promise<void> {
    if (!this.isValidForm() ) { return; }

    try {
      await this.usersService.changePassword(this.form.Nuevacontrasena, this.hash);

      await Swal.fire('¡Éxito!', 'Ahora puedes iniciar sesión con tu nueva contraseña', 'success');

      this.router.navigate(['/login']);
    } catch (e) {
      Swal.fire('', e.error.desc || 'Error desconocido, intente más tarde', 'error');
    } finally {
      this.initForm();
    }
  }

  isValidForm(): boolean{
    if (!this.form.Nuevacontrasena) {
      this.error = 'El campo Nueva contraseña es obligatorio';
      return false;
    }

    if (!this.form.ConfirmarNuevacontrasena) {
      this.error = 'El campo Confirmar contraseña es obligatorio';
      return false;
    }

    if (this.form.Nuevacontrasena.length <= 4) {
      this.error = 'La contraseña debe contener un mínimo de 5 caracteres';
      return false;
    }

    if (this.form.Nuevacontrasena !== this.form.ConfirmarNuevacontrasena) {
      this.error = 'El campo Nueva contraseña y Confirmar contraseña no coinciden';
      return false;
    }

    this.error = '';
    return true;
  }
}
